module.exports = __webpack_public_path__ + "img/product_fire.7266fbb.svg";